import React, { Component } from "react";
import Select from "react-select";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./MultiSelectWithDoDOrdering.scss";

/**
 * MultiSelect with drag-n-drop ordering of items. Items are rendered as block items.
 */
export default class MultiSelectWithDoDOrdering extends Component {
  handleSelectChange = (selectedOptions) => {
    let newArray = [];
    if (selectedOptions?.length > 0) {
      newArray = selectedOptions.map(option => option.value)
    }
    if (newArray.length === 0) {
      this.props.onDelete();
    } else {
      this.props.onAdd(newArray);
    }
  };

  handleDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId) {
      if (destination.index === source.index) {
        // the item stays at the same place, nothing changes
        return;
      } else {
        const newArray = [...this.props.order];
        newArray.splice(source.index, 1);
        newArray.splice(destination.index, 0, draggableId);
        this.props.onChangeOrder(newArray);
      }
    }
  };

  render() {
    // if allowSelectMultipleTimes is true, we always provide react-select with empty values
    const values = this.props.allowSelectMultipleTimes ? [] : this.props.values;

    return (
      <div className="MultiSelectWithDoDOrdering">
        <DragDropContext onDragEnd={this.handleDragEnd}>
          <Droppable droppableId="keep">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={`MultiSelectWithDoDOrdering__container ${
                  snapshot.isDraggingOver
                    ? "MultiSelectWithDoDOrdering__container--is-dragging-over"
                    : ""
                }`}
              >
                {React.Children.toArray(this.props.children).map(
                  (child, index) => {
                    return (
                      <Draggable
                        key={child.key}
                        draggableId={`${child.props.id}`}
                        index={index}
                      >
                        {(provided) =>
                          React.cloneElement(child, {
                            ...provided.draggableProps,
                            ...provided.dragHandleProps,
                            ref: provided.innerRef,
                          })
                        }
                      </Draggable>
                    );
                  }
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {this.props.hideDefaultSelect ? 
          null : 
          <Select
            closeMenuOnSelect={true}
            isDisabled={this.props.disabled}
            isMulti
            onChange={this.handleSelectChange}
            options={this.props.options}
            isClearable={true}
            placeholder={this.props.placeholder}
            value={this.props.options.filter(option => values.includes(option.value))}
            components={this.props.components}
          />
        }
      </div>
    );
  }
}
